import { ISearchProvider, ISearchResult } from "../../../../ui/components-lit/GlobalSearch/types"
import { TGlobalSearchProviderContext } from "./provider.types"

export const createUsuariosProvider = (ctx: TGlobalSearchProviderContext): ISearchProvider => {
    return {
        key: "usuarios",
        label: "Usuarios",
        subLabel: "Catalogo de usuarios del KidiAdmin",
        action: ctx.navigateModule("usuarios"),
        search: (): ISearchResult[] => ([]),
    }
}